export enum GatewayVendaEnum {
  CHRONOS = 1,
  STRIPE,
  TOTAL_SALE,
  STARK_BANK,
  MERCADO_PAGO,
}

export const GatewayVendaDescricao: {
  [key in GatewayVendaEnum]: string;
} = {
  [GatewayVendaEnum.CHRONOS]: 'Chronos',
  [GatewayVendaEnum.STRIPE]: 'Stripe',
  [GatewayVendaEnum.TOTAL_SALE]: 'Total Sale',
  [GatewayVendaEnum.STARK_BANK]: 'Stark Bank',
  [GatewayVendaEnum.MERCADO_PAGO]: 'Mercado Pago',
};
